var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.316 36.079s-2.86-15.895-3.274-17.602c2.801 0 10.736-5.725 12.612-17.7 4.46.547 6.029 2.953 5.694 6.816-.106 1.21-.586 5.493-.586 5.493l-2.322.652.211 1.447s11.789.278 14.186.342c1.537 11.276-2.065 18.254-9.302 23.415-4.14-.918-17.219-2.863-17.219-2.863zM.636 39.505L.31 17.1h3.663l5.87 22.2-9.206.205z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.8679435aea55897c3ebb8d5679367c13.svg";
export { ForwardRef as ReactComponent };